var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import _ from 'lodash';

var ViewLocationCtrl = function () {
    function ViewLocationCtrl($scope, $state, $q, StateUtils) {
        _classCallCheck(this, ViewLocationCtrl);

        this.$state = $state;
        this.model = StateUtils.activeDataForState(true).model;
        this.sessionId = SessionUtil.getSessionUUID(this.model);

        this.location = _.find(this.model.lobData.commercialProperty.coverables.locations.value, function (location) {
            return location.publicID === $state.params.publicID;
        });
    }

    _createClass(ViewLocationCtrl, [{
        key: 'toBuildingsList',
        value: function toBuildingsList() {
            this.$state.go('cpBuildingWizardBuildingsList');
        }
    }, {
        key: 'toEditLocation',
        value: function toEditLocation() {
            this.$state.go('cpBuildingWizardEditLocation', { publicID: this.location.publicID });
        }
    }]);

    return ViewLocationCtrl;
}();

ViewLocationCtrl.$inject = ['$scope', '$state', '$q', 'StateUtils'];

export default ViewLocationCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/ViewLocation/ViewLocationCtrl.js
// module id = 1827
// module chunks = 0